import { useEffect } from '@frontend/react';
import { LoadingSpinnerPanel } from '@frontend/web-react';
import { useReengagementActivateMutation, useRetrieveClientQuery } from '@frontend/web/hooks';
import { redirectUnauthenticated } from '@frontend/web/utils/router';
import { createFileRoute, useNavigate } from '@tanstack/react-router';

const TrialActivate = () => {
  const navigate = useNavigate();
  const [reengagementActivate] = useReengagementActivateMutation();
  const { refetch: refetchClient } = useRetrieveClientQuery();

  useEffect(() => {
    reengagementActivate()
      .unwrap()
      .then(async (response) => {
        await refetchClient();
        navigate({ to: response.redirect });
      })
      .catch(() => {
        navigate({ to: '/onboarding/membership' });
      });
  }, []);

  return <LoadingSpinnerPanel fullScreen />;
};

export const Route = createFileRoute('/trial/activate')({
  beforeLoad: ({ context, location }) => {
    redirectUnauthenticated({ context, location });
  },
  component: TrialActivate,
});
